export const phoneCountryCodeList = [
  { country: "Afghanistan", code: "93", iso: "AF" },
  { country: "Albania", code: "355", iso: "AL" },
  { country: "Algeria", code: "213", iso: "DZ" },
  { country: "Samoa Americane", code: "1-684", iso: "AS" },
  { country: "Andorra", code: "376", iso: "AD" },
  { country: "Angola", code: "244", iso: "AO" },
  { country: "Anguilla", code: "1-264", iso: "AI" },
  { country: "Antartide", code: "672", iso: "AQ" },
  { country: "Antigua e Barbuda", code: "1-268", iso: "AG" },
  { country: "Argentina", code: "54", iso: "AR" },
  { country: "Armenia", code: "374", iso: "AM" },
  { country: "Aruba", code: "297", iso: "AW" },
  { country: "Australia", code: "61", iso: "AU" },
  { country: "Austria", code: "43", iso: "AT" },
  { country: "Azerbaigian", code: "994", iso: "AZ" },
  { country: "Bahamas", code: "1-242", iso: "BS" },
  { country: "Bahrein", code: "973", iso: "BH" },
  { country: "Bangladesh", code: "880", iso: "BD" },
  { country: "Barbados", code: "1-246", iso: "BB" },
  { country: "Bielorussia", code: "375", iso: "BY" },
  { country: "Belgio", code: "32", iso: "BE" },
  { country: "Belize", code: "501", iso: "BZ" },
  { country: "Benin", code: "229", iso: "BJ" },
  { country: "Bermuda", code: "1-441", iso: "BM" },
  { country: "Bhutan", code: "975", iso: "BT" },
  { country: "Bolivia", code: "591", iso: "BO" },
  { country: "Bosnia ed Erzegovina", code: "387", iso: "BA" },
  { country: "Botswana", code: "267", iso: "BW" },
  { country: "Brasile", code: "55", iso: "BR" },
  {
    country: "Territorio Britannico dell'Oceano Indiano",
    code: "246",
    iso: "IO",
  },
  { country: "Isole Vergini Britanniche", code: "1-284", iso: "VG" },
  { country: "Brunei", code: "673", iso: "BN" },
  { country: "Bulgaria", code: "359", iso: "BG" },
  { country: "Burkina Faso", code: "226", iso: "BF" },
  { country: "Burundi", code: "257", iso: "BI" },
  { country: "Cambogia", code: "855", iso: "KH" },
  { country: "Camerun", code: "237", iso: "CM" },
  { country: "Canada", code: "1", iso: "CA" },
  { country: "Capo Verde", code: "238", iso: "CV" },
  { country: "Isole Cayman", code: "1-345", iso: "KY" },
  { country: "Repubblica Centrafricana", code: "236", iso: "CF" },
  { country: "Ciad", code: "235", iso: "TD" },
  { country: "Cile", code: "56", iso: "CL" },
  { country: "Cina", code: "86", iso: "CN" },
  { country: "Isola Christmas", code: "61", iso: "CX" },
  { country: "Isole Cocos", code: "61", iso: "CC" },
  { country: "Colombia", code: "57", iso: "CO" },
  { country: "Comore", code: "269", iso: "KM" },
  { country: "Isole Cook", code: "682", iso: "CK" },
  { country: "Costa Rica", code: "506", iso: "CR" },
  { country: "Croazia", code: "385", iso: "HR" },
  { country: "Cuba", code: "53", iso: "CU" },
  { country: "Curaçao", code: "599", iso: "CW" },
  { country: "Cipro", code: "357", iso: "CY" },
  { country: "Repubblica Ceca", code: "420", iso: "CZ" },
  { country: "Repubblica Democratica del Congo", code: "243", iso: "CD" },
  { country: "Danimarca", code: "45", iso: "DK" },
  { country: "Gibuti", code: "253", iso: "DJ" },
  { country: "Dominica", code: "1-767", iso: "DM" },
  { country: "Repubblica Dominicana", code: "1-809, 1-829, 1-849", iso: "DO" },
  { country: "Timor Est", code: "670", iso: "TL" },
  { country: "Ecuador", code: "593", iso: "EC" },
  { country: "Egitto", code: "20", iso: "EG" },
  { country: "El Salvador", code: "503", iso: "SV" },
  { country: "Guinea Equatoriale", code: "240", iso: "GQ" },
  { country: "Eritrea", code: "291", iso: "ER" },
  { country: "Estonia", code: "372", iso: "EE" },
  { country: "Etiopia", code: "251", iso: "ET" },
  { country: "Isole Falkland", code: "500", iso: "FK" },
  { country: "Isole Fær Øer", code: "298", iso: "FO" },
  { country: "Fiji", code: "679", iso: "FJ" },
  { country: "Finlandia", code: "358", iso: "FI" },
  { country: "Francia", code: "33", iso: "FR" },
  { country: "Polinesia Francese", code: "689", iso: "PF" },
  { country: "Gabon", code: "241", iso: "GA" },
  { country: "Gambia", code: "220", iso: "GM" },
  { country: "Georgia", code: "995", iso: "GE" },
  { country: "Germania", code: "49", iso: "DE" },
  { country: "Ghana", code: "233", iso: "GH" },
  { country: "Gibilterra", code: "350", iso: "GI" },
  { country: "Grecia", code: "30", iso: "GR" },
  { country: "Groenlandia", code: "299", iso: "GL" },
  { country: "Grenada", code: "1-473", iso: "GD" },
  { country: "Guam", code: "1-671", iso: "GU" },
  { country: "Guatemala", code: "502", iso: "GT" },
  { country: "Guernsey", code: "44-1481", iso: "GG" },
  { country: "Guinea", code: "224", iso: "GN" },
  { country: "Guinea-Bissau", code: "245", iso: "GW" },
  { country: "Guyana", code: "592", iso: "GY" },
  { country: "Haiti", code: "509", iso: "HT" },
  { country: "Honduras", code: "504", iso: "HN" },
  { country: "Hong Kong", code: "852", iso: "HK" },
  { country: "Ungheria", code: "36", iso: "HU" },
  { country: "Islanda", code: "354", iso: "IS" },
  { country: "India", code: "91", iso: "IN" },
  { country: "Indonesia", code: "62", iso: "ID" },
  { country: "Iran", code: "98", iso: "IR" },
  { country: "Iraq", code: "964", iso: "IQ" },
  { country: "Irlanda", code: "353", iso: "IE" },
  { country: "Isola di Man", code: "44-1624", iso: "IM" },
  { country: "Israele", code: "972", iso: "IL" },
  { country: "Italia", code: "39", iso: "IT" },
  { country: "Costa d'Avorio", code: "225", iso: "CI" },
  { country: "Giamaica", code: "1-876", iso: "JM" },
  { country: "Giappone", code: "81", iso: "JP" },
  { country: "Jersey", code: "44-1534", iso: "JE" },
  { country: "Giordania", code: "962", iso: "JO" },
  { country: "Kazakistan", code: "7", iso: "KZ" },
  { country: "Kenya", code: "254", iso: "KE" },
  { country: "Kiribati", code: "686", iso: "KI" },
  { country: "Kosovo", code: "383", iso: "XK" },
  { country: "Kuwait", code: "965", iso: "KW" },
  { country: "Kirghizistan", code: "996", iso: "KG" },
  { country: "Laos", code: "856", iso: "LA" },
  { country: "Lettonia", code: "371", iso: "LV" },
  { country: "Libano", code: "961", iso: "LB" },
  { country: "Lesotho", code: "266", iso: "LS" },
  { country: "Liberia", code: "231", iso: "LR" },
  { country: "Libia", code: "218", iso: "LY" },
  { country: "Liechtenstein", code: "423", iso: "LI" },
  { country: "Lituania", code: "370", iso: "LT" },
  { country: "Lussemburgo", code: "352", iso: "LU" },
  { country: "Macao", code: "853", iso: "MO" },
  { country: "Macedonia del Nord", code: "389", iso: "MK" },
  { country: "Madagascar", code: "261", iso: "MG" },
  { country: "Malawi", code: "265", iso: "MW" },
  { country: "Malesia", code: "60", iso: "MY" },
  { country: "Maldive", code: "960", iso: "MV" },
  { country: "Mali", code: "223", iso: "ML" },
  { country: "Malta", code: "356", iso: "MT" },
  { country: "Isole Marshall", code: "692", iso: "MH" },
  { country: "Mauritania", code: "222", iso: "MR" },
  { country: "Mauritius", code: "230", iso: "MU" },
  { country: "Mayotte", code: "262", iso: "YT" },
  { country: "Messico", code: "52", iso: "MX" },
  { country: "Micronesia", code: "691", iso: "FM" },
  { country: "Moldavia", code: "373", iso: "MD" },
  { country: "Monaco", code: "377", iso: "MC" },
  { country: "Mongolia", code: "976", iso: "MN" },
  { country: "Montenegro", code: "382", iso: "ME" },
  { country: "Montserrat", code: "1-664", iso: "MS" },
  { country: "Marocco", code: "212", iso: "MA" },
  { country: "Mozambico", code: "258", iso: "MZ" },
  { country: "Myanmar", code: "95", iso: "MM" },
  { country: "Namibia", code: "264", iso: "NA" },
  { country: "Nauru", code: "674", iso: "NR" },
  { country: "Nepal", code: "977", iso: "NP" },
  { country: "Paesi Bassi", code: "31", iso: "NL" },
  { country: "Antille Olandesi", code: "599", iso: "AN" },
  { country: "Nuova Caledonia", code: "687", iso: "NC" },
  { country: "Nuova Zelanda", code: "64", iso: "NZ" },
  { country: "Nicaragua", code: "505", iso: "NI" },
  { country: "Niger", code: "227", iso: "NE" },
  { country: "Nigeria", code: "234", iso: "NG" },
  { country: "Niue", code: "683", iso: "NU" },
  { country: "Corea del Nord", code: "850", iso: "KP" },
  { country: "Isole Marianne Settentrionali", code: "1-670", iso: "MP" },
  { country: "Norvegia", code: "47", iso: "NO" },
  { country: "Oman", code: "968", iso: "OM" },
  { country: "Pakistan", code: "92", iso: "PK" },
  { country: "Palau", code: "680", iso: "PW" },
  { country: "Palestina", code: "970", iso: "PS" },
  { country: "Panama", code: "507", iso: "PA" },
  { country: "Papua Nuova Guinea", code: "675", iso: "PG" },
  { country: "Paraguay", code: "595", iso: "PY" },
  { country: "Perù", code: "51", iso: "PE" },
  { country: "Filippine", code: "63", iso: "PH" },
  { country: "Isole Pitcairn", code: "64", iso: "PN" },
  { country: "Polonia", code: "48", iso: "PL" },
  { country: "Portogallo", code: "351", iso: "PT" },
  { country: "Porto Rico", code: "1-787, 1-939", iso: "PR" },
  { country: "Qatar", code: "974", iso: "QA" },
  { country: "Repubblica del Congo", code: "242", iso: "CG" },
  { country: "Riunione", code: "262", iso: "RE" },
  { country: "Romania", code: "40", iso: "RO" },
  { country: "Russia", code: "7", iso: "RU" },
  { country: "Ruanda", code: "250", iso: "RW" },
  { country: "Saint-Barthélemy", code: "590", iso: "BL" },
  { country: "Sant'Elena", code: "290", iso: "SH" },
  { country: "Saint Kitts e Nevis", code: "1-869", iso: "KN" },
  { country: "Santa Lucia", code: "1-758", iso: "LC" },
  { country: "Saint-Martin", code: "590", iso: "MF" },
  { country: "Saint-Pierre e Miquelon", code: "508", iso: "PM" },
  { country: "Saint Vincent e Grenadine", code: "1-784", iso: "VC" },
  { country: "Samoa", code: "685", iso: "WS" },
  { country: "San Marino", code: "378", iso: "SM" },
  { country: "São Tomé e Príncipe", code: "239", iso: "ST" },
  { country: "Arabia Saudita", code: "966", iso: "SA" },
  { country: "Senegal", code: "221", iso: "SN" },
  { country: "Serbia", code: "381", iso: "RS" },
  { country: "Seychelles", code: "248", iso: "SC" },
  { country: "Sierra Leone", code: "232", iso: "SL" },
  { country: "Singapore", code: "65", iso: "SG" },
  { country: "Sint Maarten", code: "1-721", iso: "SX" },
  { country: "Slovacchia", code: "421", iso: "SK" },
  { country: "Slovenia", code: "386", iso: "SI" },
  { country: "Isole Salomone", code: "677", iso: "SB" },
  { country: "Somalia", code: "252", iso: "SO" },
  { country: "Sudafrica", code: "27", iso: "ZA" },
  { country: "Corea del Sud", code: "82", iso: "KR" },
  { country: "Sudan del Sud", code: "211", iso: "SS" },
  { country: "Spagna", code: "34", iso: "ES" },
  { country: "Sri Lanka", code: "94", iso: "LK" },
  { country: "Sudan", code: "249", iso: "SD" },
  { country: "Suriname", code: "597", iso: "SR" },
  { country: "Svalbard e Jan Mayen", code: "47", iso: "SJ" },
  { country: "eSwatini", code: "268", iso: "SZ" },
  { country: "Svezia", code: "46", iso: "SE" },
  { country: "Svizzera", code: "41", iso: "CH" },
  { country: "Siria", code: "963", iso: "SY" },
  { country: "Taiwan", code: "886", iso: "TW" },
  { country: "Tagikistan", code: "992", iso: "TJ" },
  { country: "Tanzania", code: "255", iso: "TZ" },
  { country: "Tailandia", code: "66", iso: "TH" },
  { country: "Togo", code: "228", iso: "TG" },
  { country: "Tokelau", code: "690", iso: "TK" },
  { country: "Tonga", code: "676", iso: "TO" },
  { country: "Trinidad e Tobago", code: "1-868", iso: "TT" },
  { country: "Tunisia", code: "216", iso: "TN" },
  { country: "Turchia", code: "90", iso: "TR" },
  { country: "Turkmenistan", code: "993", iso: "TM" },
  { country: "Isole Turks e Caicos", code: "1-649", iso: "TC" },
  { country: "Tuvalu", code: "688", iso: "TV" },
  { country: "Isole Vergini Americane", code: "1-340", iso: "VI" },
  { country: "Uganda", code: "256", iso: "UG" },
  { country: "Ucraina", code: "380", iso: "UA" },
  { country: "Emirati Arabi Uniti", code: "971", iso: "AE" },
  { country: "Regno Unito", code: "44", iso: "GB" },
  { country: "Stati Uniti", code: "1", iso: "US" },
  { country: "Uruguay", code: "598", iso: "UY" },
  { country: "Uzbekistan", code: "998", iso: "UZ" },
  { country: "Vanuatu", code: "678", iso: "VU" },
  { country: "Vaticano", code: "379", iso: "VA" },
  { country: "Venezuela", code: "58", iso: "VE" },
  { country: "Vietnam", code: "84", iso: "VN" },
  { country: "Wallis e Futuna", code: "681", iso: "WF" },
  { country: "Sahara Occidentale", code: "212", iso: "EH" },
  { country: "Yemen", code: "967", iso: "YE" },
  { country: "Zambia", code: "260", iso: "ZM" },
  { country: "Zimbabwe", code: "263", iso: "ZW" },
];
